<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg1533"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs1537"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath1567"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path1565" /></clipPath></defs><g
     id="g1539"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g1541"
       transform="translate(193.9185,330.3359)"><path
         d="M 0,0 H -58.418"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path1543" /></g><g
       id="g1545"
       transform="translate(189.5796,298.7466)"><path
         d="M 0,0 H -54.08"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path1547" /></g><g
       id="g1549"
       transform="translate(185.645,267.1572)"><path
         d="M 0,0 H -50.145"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path1551" /></g><g
       id="g1553"
       transform="translate(163.6665,166.6909)"><path
         d="M 0,0 H 66.667"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path1555" /></g><g
       id="g1557"
       transform="translate(163.6665,135.3574)"><path
         d="M 0,0 H 66.667"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path1559" /></g><g
       id="g1561"><g
         id="g1563"
         clip-path="url(#clipPath1567)"><g
           id="g1569"
           transform="translate(44.8652,329.499)"><path
             d="m 0,0 v 17.255 c 0,7.514 -6.092,13.606 -13.606,13.606 h -10.153 c -7.514,0 -13.606,-6.092 -13.606,-13.606 v -91.99 c 0,-7.515 6.092,-13.606 13.606,-13.606 h 10.153 C -6.092,-88.341 0,-82.25 0,-74.735 v 39.672"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1571" /></g><g
           id="g1573"
           transform="translate(44.7188,252.8745)"><path
             d="m 0,0 h 23.858 c 3.523,0 7.014,-0.669 10.287,-1.973 l 22.577,-8.994 c 17.306,-5.9 30.642,-6.34 48.167,-6.34 h 15.114 l 7.184,-0.048 c 0.399,0 0.795,0.02 1.189,0.048 h 6.666 c 8.724,0 15.795,7.072 15.795,15.795 0,8.723 -7.071,15.795 -15.795,15.795 h 6.733 c 8.723,0 15.794,7.071 15.794,15.794 0,8.723 -7.071,15.795 -15.794,15.795 h 7.425 c 8.723,0 15.794,7.071 15.794,15.795 0,8.468 -6.67,15.36 -15.041,15.756 v 0.004 c 8.729,-0.005 15.806,7.07 15.806,15.797 v 0 c 0,0.005 -10e-4,0.009 -10e-4,0.014 0,0.006 10e-4,0.012 10e-4,0.018 0,8.723 -7.072,15.795 -15.795,15.795 H 96.168 l -6.445,0.003 c -7.871,0.005 -14.25,6.387 -14.25,14.258 v 9.909 C 62.824,132.596 50.636,127.397 42.783,117.424 L 34.344,106.708 C 29.074,100.016 21.026,96.11 12.508,96.11 h -12.56"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1575" /></g><g
           id="g1577"
           transform="translate(391.1611,170.5957)"><path
             d="m 0,0 c 3.389,-2.091 6.198,-5.11 8.014,-8.824 4.309,-8.817 13.232,-14.867 23.771,-14.867"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1579" /></g><g
           id="g1581"
           transform="translate(467.333,204.0806)"><path
             d="m 0,0 h -12.56 c -8.518,0 -16.565,3.906 -21.836,10.598 l -8.438,10.717 c -4.868,6.181 -11.902,11.1 -20.72,13.753 -3.498,1.053 -7.388,1.767 -11.409,2.009 V 28.373 C -74.963,14.979 -85.821,4.12 -99.216,4.12 h -24.532 c -9.486,0 -17.175,-7.69 -17.175,-17.175 0,-9.505 7.704,-17.176 17.175,-17.176 h 36.085 c 4.636,0 9.063,-1.463 12.7,-4.058 v -56.526 -0.002 -13.661 c 0,-2.584 -0.439,-5.064 -1.236,-7.378 6.188,0.933 12.488,2.414 19.426,4.779 l 22.577,8.994 c 3.272,1.304 6.762,1.974 10.285,1.974 h 23.859"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1583" /></g><g
           id="g1585"
           transform="translate(480.7412,215.4565)"><path
             d="m 0,0 h 10.152 c 7.515,0 13.607,-6.092 13.607,-13.606 v -91.99 c 0,-7.514 -6.092,-13.606 -13.607,-13.606 H 0 c -7.515,0 -13.606,6.092 -13.606,13.606 v 91.99 C -13.606,-6.092 -7.515,0 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1587" /></g><g
           id="g1589"
           transform="translate(388.1719,367.6768)"><path
             d="m 0,0 -63.172,63.171 c -1.224,1.224 -2.653,2.19 -4.198,2.894 V 18.451 c 0,-12.509 10.141,-22.649 22.65,-22.649 H 2.893 C 2.189,-2.653 1.224,-1.224 0,0 Z"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1591" /></g><g
           id="g1593"
           transform="translate(392.3696,333.8091)"><path
             d="m 0,0 v 23.732 c 0,3.802 -1.51,7.448 -4.198,10.136 L -67.37,97.039 c -2.687,2.688 -6.333,4.198 -10.134,4.198 h -172.03 c -12.509,0 -22.65,-10.14 -22.65,-22.649 V 52.286 c 0.002,0 0.004,10e-4 0.006,10e-4"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1595" /></g><g
           id="g1597"
           transform="translate(392.3696,241.1577)"><path
             d="M 0,0 V 57.589"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1599" /></g><g
           id="g1601"
           transform="translate(120.186,237.231)"><path
             d="m 0,0 v -137.628 c 0,-12.509 10.141,-22.649 22.649,-22.649 h 226.886 c 12.604,0 22.649,10.256 22.649,22.649"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path1603" /></g></g></g></g></svg>
</template>
